module.exports = __webpack_public_path__ + "static/media/engine-power.ec7b3979.svg";